import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=0f4e0332&scoped=true"
import script from "./couponDetail.vue?vue&type=script&lang=ts"
export * from "./couponDetail.vue?vue&type=script&lang=ts"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=0f4e0332&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e0332",
  null
  
)

export default component.exports